import React, { useEffect, useRef } from "react";

import {
  ContentSeparator,
  ContentWrapper,
  Description,
  DescriptionInput,
  DetailsWrapper,
  Title,
} from "./styles";

type ProjectDetailsProps = {
  setName: (name: string) => void;
  setDescription: (description: string) => void;
  name: string;
  description: string;
};

export const ProjectDetails = ({
  setName,
  setDescription,
  name,
  description,
}: ProjectDetailsProps) => {
  const ref = useRef<HTMLTextAreaElement>(null);
  const titleRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const textarea = ref.current;
    if (textarea) {
      textarea.style.maxHeight = "72px";
      textarea.style.height = "14px";
      textarea.style.height = textarea.scrollHeight + "px";
    }
  }, [description]);

  useEffect(() => {
    const textarea = titleRef.current;
    if (textarea) {
      textarea.style.maxHeight = "78px";
      textarea.style.height = "14px";
      textarea.style.height = textarea.scrollHeight + "px";
    }
  }, [name]);

  return (
    <DetailsWrapper>
      <ContentWrapper>
        <Title
          title="Name your project"
          placeholder="Name your project"
          onChange={(e) => setName(e.target.value)}
          value={name}
          ref={titleRef}
          wrap="hard"
          maxLength={60}
        />
        <Description>Description</Description>
        <DescriptionInput
          placeholder="Add description"
          onChange={(e) => setDescription(e.target.value)}
          ref={ref}
          value={description}
          maxLength={200}
        />
      </ContentWrapper>
      <ContentSeparator />
    </DetailsWrapper>
  );
};
